import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"copy\"><title>copy</title><path d=\"M13.672 3.719L10.328.328q-.109-.094-.234-.172-.047-.031-.063-.031-.016-.016-.047-.031Q9.765 0 9.531 0H5.14q-.469 0-.805.328t-.336.797V2h-.875q-.453 0-.789.336t-.336.789v11.75q0 .469.336.797t.789.328h7.75q.453 0 .781-.328t.328-.797V14h.891q.469 0 .789-.328t.32-.797V4.5q0-.469-.313-.781zm-3.563-2l2.141 2.156h-2.141V1.719zm.75 13.156H3.125V3.125H4v9.75q0 .469.336.797t.805.328h5.719v.875zm2-2H5.125V1.125h3.859v2.75q0 .469.336.797t.805.328h2.734v7.875zM10 6.563q0-.234-.164-.398t-.398-.164H6.563q-.234 0-.398.164t-.164.398.164.398.398.164h2.875q.234 0 .398-.164T10 6.563zm2 2q0-.234-.164-.398t-.398-.164H6.563q-.234 0-.398.164t-.164.398.164.398.398.164h4.875q.234 0 .398-.164T12 8.563zm-1 2q0-.234-.164-.398t-.398-.164H6.563q-.234 0-.398.164t-.164.398.164.398.398.164h3.875q.234 0 .398-.164t.164-.398z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/copy.svg
// module id = 516
// module chunks = 0